export const comicCategories = [
  { slug: "all", name: "全部", icon: "ri-apps-line" },
  { slug: "romance", name: "恋爱", icon: "ri-heart-line" },
  { slug: "fantasy", name: "奇幻", icon: "ri-magic-line" },
  { slug: "action", name: "动作", icon: "ri-flashlight-line" },
  { slug: "comedy", name: "搞笑", icon: "ri-emotion-laugh-line" },
  { slug: "thriller", name: "悬疑", icon: "ri-eye-line" },
  { slug: "drama", name: "剧情", icon: "ri-film-line" },
  { slug: "slice-of-life", name: "日常", icon: "ri-sun-line" },
];

export interface ComicChapter {
  id: string;
  title: string;
  number: number;
  date: string;
  views: number;
}

export interface Comic {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  description: string;
  categories: string[];
  status: string;
  rating: number;
  totalViews: number;
  totalChapters: number;
  updatedAt: string;
  isHot: boolean;
  isNew: boolean;
  isRecommended: boolean;
  chapters: ComicChapter[];
}

export const comics: Comic[] = [
  {
    id: "comic-1",
    title: "再见，我的公主",
    author: "金敏秀",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%20art%20style%2C%20beautiful%20princess%20with%20long%20hair%20in%20elegant%20dress%2C%20soft%20pastel%20colors%2C%20romantic%20atmosphere%2C%20delicate%20linework%2C%20dreamy%20background%20with%20flowers%20and%20castle%20silhouette%2C%20clean%20minimal%20composition&width=400&height=560&seq=comic-1-cover&orientation=portrait",
    description: "在一个充满魔法与宫廷斗争的王国里，一位被误解的公主踏上了寻找真相的旅程。她必须面对过去的秘密，以及那个曾经离她而去的骑士。这是一个关于爱情、背叛与救赎的动人故事，每一页都充满了细腻的情感描绘和令人屏息的画面。",
    categories: ["romance", "fantasy"],
    status: "连载中",
    rating: 9.5,
    totalViews: 2580000,
    totalChapters: 86,
    updatedAt: "2026-08-03",
    isHot: true,
    isNew: false,
    isRecommended: true,
    chapters: [
      { id: "ch-1-86", title: "第86话 - 真相的彼岸", number: 86, date: "2026-08-03", views: 45600 },
      { id: "ch-1-85", title: "第85话 - 暴风雨前夜", number: 85, date: "2026-07-27", views: 51200 },
      { id: "ch-1-84", title: "第84话 - 骑士的誓言", number: 84, date: "2026-07-20", views: 48900 },
      { id: "ch-1-83", title: "第83话 - 城堡的秘密", number: 83, date: "2026-07-13", views: 47300 },
      { id: "ch-1-82", title: "第82话 - 月下的约定", number: 82, date: "2026-07-06", views: 50100 },
    ],
  },
  {
    id: "comic-2",
    title: "剑尊归来",
    author: "李泰浩",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20fantasy%20cover%2C%20powerful%20swordsman%20with%20flowing%20cape%20holding%20glowing%20sword%2C%20dramatic%20lighting%2C%20dynamic%20composition%2C%20martial%20arts%20atmosphere%2C%20dark%20background%20with%20energy%20effects%2C%20clean%20epic%20style&width=400&height=560&seq=comic-2-cover&orientation=portrait",
    description: "天下第一剑尊在渡劫失败后灵魂穿越到现代，发现自己的门派已烟消云散。重获新生的他，将用千年的剑术和智慧，在现代都市中重建属于自己的武林帝国。这不仅仅是一个关于复仇的故事，更是一段关于传承与守护的壮丽史诗。",
    categories: ["action", "fantasy"],
    status: "连载中",
    rating: 9.7,
    totalViews: 4120000,
    totalChapters: 120,
    updatedAt: "2026-08-02",
    isHot: true,
    isNew: false,
    isRecommended: true,
    chapters: [
      { id: "ch-2-120", title: "第120话 - 天下第一", number: 120, date: "2026-08-02", views: 78200 },
      { id: "ch-2-119", title: "第119话 - 最后的试炼", number: 119, date: "2026-07-26", views: 75600 },
      { id: "ch-2-118", title: "第118话 - 龙脉觉醒", number: 118, date: "2026-07-19", views: 80100 },
    ],
  },
  {
    id: "comic-3",
    title: "社内恋爱禁止令",
    author: "韩智慧",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20office%20romance%20cover%2C%20young%20couple%20in%20modern%20office%20setting%2C%20warm%20lighting%2C%20contemporary%20fashion%2C%20romantic%20comedy%20vibe%2C%20clean%20illustration%20style%2C%20soft%20colors%2C%20city%20skyline%20through%20window&width=400&height=560&seq=comic-3-cover&orientation=portrait",
    description: "在大企业工作的她，意外与公司高层签订了秘密恋爱契约。两个性格截然不同的人在「禁止办公室恋情」的铁律下，展开了充满笑料与心跳的隐秘罗曼史。当秘密面临暴露的危机，他们该如何保护彼此，又该如何守护这段感情？",
    categories: ["romance", "comedy", "drama"],
    status: "连载中",
    rating: 9.3,
    totalViews: 1890000,
    totalChapters: 64,
    updatedAt: "2026-08-01",
    isHot: true,
    isNew: false,
    isRecommended: false,
    chapters: [
      { id: "ch-3-64", title: "第64话 - 危机来临", number: 64, date: "2026-08-01", views: 34500 },
      { id: "ch-3-63", title: "第63话 - 心跳的瞬间", number: 63, date: "2026-07-25", views: 36700 },
      { id: "ch-3-62", title: "第62话 - 不速之客", number: 62, date: "2026-07-18", views: 35200 },
    ],
  },
  {
    id: "comic-4",
    title: "末日生存法则",
    author: "朴正宇",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20post-apocalyptic%20cover%2C%20survivor%20in%20ruined%20cityscape%2C%20dramatic%20orange%20and%20dark%20atmosphere%2C%20gritty%20art%20style%2C%20tense%20action%20scene%2C%20destroyed%20buildings%20background%2C%20lone%20figure%20silhouette&width=400&height=560&seq=comic-4-cover&orientation=portrait",
    description: "一场突如其来的病毒席卷全球，文明在瞬间崩塌。普通人金俊浩在末日中觉醒特殊能力，为了守护身边的同伴，他不得不在人性的黑暗与希望的光明之间做出抉择。在这片废土之上，每一个选择都可能意味着生死。",
    categories: ["action", "thriller", "drama"],
    status: "连载中",
    rating: 9.4,
    totalViews: 3210000,
    totalChapters: 95,
    updatedAt: "2026-08-03",
    isHot: true,
    isNew: false,
    isRecommended: true,
    chapters: [
      { id: "ch-4-95", title: "第95话 - 新世界", number: 95, date: "2026-08-03", views: 63400 },
      { id: "ch-4-94", title: "第94话 - 最后的据点", number: 94, date: "2026-07-27", views: 59800 },
    ],
  },
  {
    id: "comic-5",
    title: "我家猫变成美少女",
    author: "崔多恩",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20fantasy%20cover%2C%20cute%20cat-girl%20character%20with%20cat%20ears%2C%20bright%20cheerful%20atmosphere%2C%20slice%20of%20life%20style%2C%20warm%20pastel%20colors%2C%20modern%20apartment%20background%2C%20playful%20expression&width=400&height=560&seq=comic-5-cover&orientation=portrait",
    description: "独自生活的程序员某天早上醒来，发现自家养的猫竟然变成了美少女！从此开始了一段搞笑又温馨的同居生活。从不会用筷子到学会网购，这个超萌的猫娘将如何适应人类世界？而主人又能否接受这个从天而降的「猫系女友」呢？",
    categories: ["comedy", "fantasy", "slice-of-life"],
    status: "连载中",
    rating: 9.1,
    totalViews: 1450000,
    totalChapters: 52,
    updatedAt: "2026-07-31",
    isHot: false,
    isNew: true,
    isRecommended: false,
    chapters: [
      { id: "ch-5-52", title: "第52话 - 第一次约会", number: 52, date: "2026-07-31", views: 28900 },
      { id: "ch-5-51", title: "第51话 - 猫咪的秘密", number: 51, date: "2026-07-24", views: 30100 },
    ],
  },
  {
    id: "comic-6",
    title: "漆黑的追踪者",
    author: "尹在赫",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20thriller%20mystery%20cover%2C%20detective%20in%20dark%20alley%20with%20trench%20coat%2C%20noir%20atmosphere%2C%20rainy%20night%20scene%2C%20neon%20lights%20reflecting%20on%20wet%20street%2C%20suspenseful%20mood%2C%20film%20noir%20inspired&width=400&height=560&seq=comic-6-cover&orientation=portrait",
    description: "首尔深夜，连续杀人事件震惊全城。退隐多年的前刑警被卷入这场惊心动魄的追凶之旅。每一个线索都指向一个更大的阴谋，而真相远比想象中更加黑暗。当正义与复仇的界限变得模糊，他能否在堕入黑暗之前阻止下一个受害者？",
    categories: ["thriller", "drama", "action"],
    status: "已完结",
    rating: 9.6,
    totalViews: 3670000,
    totalChapters: 110,
    updatedAt: "2026-06-15",
    isHot: false,
    isNew: false,
    isRecommended: true,
    chapters: [
      { id: "ch-6-110", title: "第110话 - 真相（完）", number: 110, date: "2026-06-15", views: 125000 },
      { id: "ch-6-109", title: "第109话 - 最后的对决", number: 109, date: "2026-06-08", views: 118000 },
    ],
  },
  {
    id: "comic-7",
    title: "异世界食堂",
    author: "张美妍",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20food%20fantasy%20cover%2C%20cozy%20restaurant%20interior%20with%20delicious%20food%20dishes%2C%20warm%20golden%20lighting%2C%20fantasy%20element%20subtle%20magical%20glow%2C%20comforting%20atmosphere%2C%20detailed%20food%20illustration&width=400&height=560&seq=comic-7-cover&orientation=portrait",
    description: "在异世界的街角，有一家只有有缘人才能找到的神秘食堂。这里的每一道菜都有着神奇的力量——能治愈心灵的创伤、唤醒沉睡的记忆。来自各行各业的客人们，在这里用一顿饭的时光，品尝着人生的酸甜苦辣。",
    categories: ["fantasy", "slice-of-life", "drama"],
    status: "连载中",
    rating: 9.2,
    totalViews: 980000,
    totalChapters: 38,
    updatedAt: "2026-07-30",
    isHot: false,
    isNew: true,
    isRecommended: false,
    chapters: [
      { id: "ch-7-38", title: "第38话 - 记忆中的味道", number: 38, date: "2026-07-30", views: 15600 },
      { id: "ch-7-37", title: "第37话 - 神秘的新客人", number: 37, date: "2026-07-23", views: 16200 },
    ],
  },
  {
    id: "comic-8",
    title: "女王陛下的人工智能",
    author: "郑秀雅",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20sci-fi%20romance%20cover%2C%20futuristic%20royal%20lady%20with%20holographic%20interface%2C%20sleek%20technology%20aesthetic%2C%20blend%20of%20historical%20and%20futuristic%20elements%2C%20elegant%20composition%2C%20soft%20blue%20and%20gold%20accents&width=400&height=560&seq=comic-8-cover&orientation=portrait",
    description: "科技帝国的女王在失去所有亲人后，按照遗嘱继承了一个神秘的人工智能系统。然而这个AI不仅拥有独立思考能力，还似乎带着已故恋人的记忆。在权力与情感的交织中，她开始质疑：什么是真正的「活着」，什么又是真正的「爱」？",
    categories: ["romance", "drama", "fantasy"],
    status: "连载中",
    rating: 9.0,
    totalViews: 1120000,
    totalChapters: 45,
    updatedAt: "2026-07-29",
    isHot: false,
    isNew: true,
    isRecommended: false,
    chapters: [
      { id: "ch-8-45", title: "第45话 - 觉醒", number: 45, date: "2026-07-29", views: 22400 },
      { id: "ch-8-44", title: "第44话 - 代码中的情感", number: 44, date: "2026-07-22", views: 21800 },
    ],
  },
  {
    id: "comic-9",
    title: "热血高校篮球部",
    author: "姜贤宇",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20sports%20basketball%20cover%2C%20dynamic%20basketball%20player%20dunking%2C%20school%20gymnasium%20background%2C%20energetic%20action%20scene%2C%20team%20spirit%20vibe%2C%20warm%20sunset%20light%20through%20windows%2C%20inspiring%20sports%20illustration&width=400&height=560&seq=comic-9-cover&orientation=portrait",
    description: "曾经是全国冠军的篮球名校，如今却濒临废部。高一新生韩宇镇凭借着对篮球的无限热爱，召集了一群性格迥异的队友，向着全国大赛的舞台发起冲击。这是一部关于青春、汗水与友谊的热血运动漫画！",
    categories: ["action", "drama"],
    status: "连载中",
    rating: 9.3,
    totalViews: 2030000,
    totalChapters: 72,
    updatedAt: "2026-08-02",
    isHot: false,
    isNew: false,
    isRecommended: true,
    chapters: [
      { id: "ch-9-72", title: "第72话 - 命运的对决", number: 72, date: "2026-08-02", views: 41200 },
      { id: "ch-9-71", title: "第71话 - 绝地反击", number: 71, date: "2026-07-26", views: 39800 },
    ],
  },
  {
    id: "comic-10",
    title: "转生成为反派千金",
    author: "金秀珍",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20villainess%20reincarnation%20cover%2C%20elegant%20noble%20lady%20in%20victorian%20style%20dress%2C%20palace%20ballroom%20background%2C%20dramatic%20lighting%2C%20royal%20atmosphere%2C%20sophisticated%20art%20style&width=400&height=560&seq=comic-10-cover&orientation=portrait",
    description: "意外身亡后，她发现自己转生成了自己最爱的乙女游戏中的反派千金！知晓全部剧情的她决定避开所有死亡Flag，过上平静的生活。然而，王子殿下却对「性格大变」的她产生了浓厚的兴趣……命运的齿轮开始转动，她能否打破原作的剧本？",
    categories: ["romance", "fantasy", "comedy"],
    status: "连载中",
    rating: 9.4,
    totalViews: 2780000,
    totalChapters: 68,
    updatedAt: "2026-08-04",
    isHot: true,
    isNew: false,
    isRecommended: true,
    chapters: [
      { id: "ch-10-68", title: "第68话 - 舞会之夜", number: 68, date: "2026-08-04", views: 52300 },
      { id: "ch-10-67", title: "第67话 - 新的危机", number: 67, date: "2026-07-28", views: 49800 },
    ],
  },
  {
    id: "comic-11",
    title: "幽灵快递员",
    author: "徐智勋",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20supernatural%20mystery%20cover%2C%20delivery%20rider%20on%20scooter%20in%20night%20city%2C%20ghostly%20figure%20appearing%2C%20urban%20fantasy%20atmosphere%2C%20mysterious%20glowing%20package%2C%20streetlights%20and%20shadows&width=400&height=560&seq=comic-11-cover&orientation=portrait",
    description: "兼职送外卖的大学生突然获得了看见鬼魂的能力。更奇怪的是，这些鬼魂开始委托他「送快递」——将未完成的遗愿传递给活着的人们。每个包裹背后都藏着一段感人至深的故事，而他也在这个过程中慢慢解开了自己的能力之谜。",
    categories: ["thriller", "drama", "slice-of-life"],
    status: "已完结",
    rating: 9.2,
    totalViews: 1560000,
    totalChapters: 80,
    updatedAt: "2026-04-20",
    isHot: false,
    isNew: false,
    isRecommended: false,
    chapters: [
      { id: "ch-11-80", title: "第80话 - 最后的快递（完）", number: 80, date: "2026-04-20", views: 89000 },
      { id: "ch-11-79", title: "第79话 - 重逢", number: 79, date: "2026-04-13", views: 84500 },
    ],
  },
  {
    id: "comic-12",
    title: "无敌奶爸的悠闲日常",
    author: "林恩智",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20family%20comedy%20cover%2C%20young%20father%20with%20baby%20in%20modern%20home%2C%20warm%20and%20funny%20atmosphere%2C%20messy%20but%20cozy%20living%20room%2C%20cute%20baby%20expressions%2C%20heartwarming%20slice%20of%20life&width=400&height=560&seq=comic-12-cover&orientation=portrait",
    description: "曾经的S级冒险者，如今全职带娃！从打怪升级到哄娃睡觉，从拯救世界到换尿布——这位最强勇者的奶爸日常充满了让人捧腹的搞笑瞬间，也有着令人感动的温馨时刻。原来，最难的副本叫做「育儿」！",
    categories: ["comedy", "slice-of-life", "drama"],
    status: "连载中",
    rating: 9.1,
    totalViews: 870000,
    totalChapters: 41,
    updatedAt: "2026-07-28",
    isHot: false,
    isNew: true,
    isRecommended: false,
    chapters: [
      { id: "ch-12-41", title: "第41话 - 公园大冒险", number: 41, date: "2026-07-28", views: 13400 },
      { id: "ch-12-40", title: "第40话 - 发烧之夜", number: 40, date: "2026-07-21", views: 14100 },
    ],
  },
  {
    id: "comic-13",
    title: "魔法学院的天才法师",
    author: "白尚勋",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20magic%20academy%20cover%2C%20young%20mage%20casting%20spell%20in%20library%2C%20magical%20sparks%20and%20glowing%20runes%2C%20academy%20uniform%2C%20grand%20library%20interior%2C%20fantasy%20atmosphere%2C%20dramatic%20lighting&width=400&height=560&seq=comic-13-cover&orientation=portrait",
    description: "出身平民的天才少年凭借惊人的魔法天赋，被历史最悠久的皇家魔法学院破格录取。然而，在这个贵族子弟云集的地方，他的存在本身就是一种挑战。面对歧视与阴谋，他将用实力证明：真正的魔法，不在于血统，而在于灵魂。",
    categories: ["fantasy", "action", "drama"],
    status: "连载中",
    rating: 9.5,
    totalViews: 3340000,
    totalChapters: 102,
    updatedAt: "2026-08-03",
    isHot: true,
    isNew: false,
    isRecommended: true,
    chapters: [
      { id: "ch-13-102", title: "第102话 - 禁术的代价", number: 102, date: "2026-08-03", views: 58900 },
      { id: "ch-13-101", title: "第101话 - 最终试炼开始", number: 101, date: "2026-07-27", views: 61200 },
    ],
  },
  {
    id: "comic-14",
    title: "深夜便利店",
    author: "安允美",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20slice%20of%20life%20cover%2C%20convenience%20store%20at%20night%20with%20warm%20interior%20lighting%2C%20young%20cashier%20behind%20counter%2C%20quiet%20urban%20night%20atmosphere%2C%20neon%20signs%20outside%2C%20melancholic%20but%20comforting%20mood&width=400&height=560&seq=comic-14-cover&orientation=portrait",
    description: "深夜的便利店，是城市中不眠人的避风港。在这里，每个深夜光顾的客人都带着属于自己的故事。打工的大学生、加班到深夜的上班族、无家可归的老人……一个个平凡的故事，串联起这座城市最真实的温度。",
    categories: ["slice-of-life", "drama"],
    status: "已完结",
    rating: 9.3,
    totalViews: 1230000,
    totalChapters: 55,
    updatedAt: "2026-05-10",
    isHot: false,
    isNew: false,
    isRecommended: false,
    chapters: [
      { id: "ch-14-55", title: "第55话 - 黎明的便利店（完）", number: 55, date: "2026-05-10", views: 45600 },
      { id: "ch-14-54", title: "第54话 - 老顾客的秘密", number: 54, date: "2026-05-03", views: 43200 },
    ],
  },
  {
    id: "comic-15",
    title: "契约婚姻百分百",
    author: "柳慧珍",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20contract%20marriage%20romance%20cover%2C%20couple%20in%20wedding%20attire%20with%20tense%20expression%2C%20luxurious%20hotel%20background%2C%20dramatic%20romantic%20atmosphere%2C%20elegant%20composition%2C%20emotional%20tension&width=400&height=560&seq=comic-15-cover&orientation=portrait",
    description: "为了拯救家族企业，她不得不与素未谋面的财阀继承人签订契约婚姻。原本以为只是一场商业交易，却在朝夕相处中渐渐被对方的温柔所打动。然而，当假戏真做的感情遭遇现实的考验，这份由契约开始的爱情能否走到最后？",
    categories: ["romance", "drama"],
    status: "连载中",
    rating: 9.4,
    totalViews: 2450000,
    totalChapters: 58,
    updatedAt: "2026-08-01",
    isHot: true,
    isNew: false,
    isRecommended: true,
    chapters: [
      { id: "ch-15-58", title: "第58话 - 心动的证明", number: 58, date: "2026-08-01", views: 48700 },
      { id: "ch-15-57", title: "第57话 - 公开的秘密", number: 57, date: "2026-07-25", views: 46300 },
    ],
  },
  {
    id: "comic-16",
    title: "网游之全职传奇",
    author: "赵明洙",
    coverImage: "https://readdy.ai/api/search-image?query=Korean%20manhwa%20gaming%20VR%20cover%2C%20warrior%20character%20in%20virtual%20reality%20game%20world%2C%20epic%20fantasy%20landscape%20background%2C%20dynamic%20action%20pose%2C%20glowing%20armor%20and%20weapons%2C%20game%20interface%20elements&width=400&height=560&seq=comic-16-cover&orientation=portrait",
    description: "在最新推出的全沉浸式虚拟现实网游中，一个被所有人嘲笑的菜鸟玩家，凭借独特的战斗理解和超乎常人的毅力，一步步登上游戏的巅峰。从最弱的职业到最强的传奇，他用行动告诉所有人：没有最强的职业，只有最强的玩家。",
    categories: ["action", "fantasy"],
    status: "连载中",
    rating: 9.1,
    totalViews: 1780000,
    totalChapters: 76,
    updatedAt: "2026-07-31",
    isHot: false,
    isNew: false,
    isRecommended: false,
    chapters: [
      { id: "ch-16-76", title: "第76话 - 世界首杀", number: 76, date: "2026-07-31", views: 35600 },
      { id: "ch-16-75", title: "第75话 - BOSS的弱点", number: 75, date: "2026-07-24", views: 34200 },
    ],
  },
];

export const bannerComics = comics.filter((c) => c.isRecommended && c.isHot).slice(0, 4);
export const hotComics = comics.filter((c) => c.isHot);
export const newComics = comics.filter((c) => c.isNew);
export const completedComics = comics.filter((c) => c.status === "已完结");

export function getComicById(id: string): Comic | undefined {
  return comics.find((c) => c.id === id);
}

export function getComicsByCategory(slug: string): Comic[] {
  if (slug === "all") return comics;
  return comics.filter((c) => c.categories.includes(slug));
}

export function getRelatedComics(comic: Comic, count: number = 4): Comic[] {
  return comics
    .filter((c) => c.id !== comic.id && c.categories.some((cat) => comic.categories.includes(cat)))
    .slice(0, count);
}